export const syncFeriasInitialState = {
  diasMarcadosEmpresa: null,
  diasMarcados: null,
  diasDisponiveis: null,
  diasTotaisFerias: null,
  editarDiasTotaisFerias: null,
  feriados: [],
};
